import { render } from "./ImmunizationRow.vue?vue&type=template&id=4a5b2eaa"
import script from "./ImmunizationRow.ts?vue&type=script&lang=js&external"
export * from "./ImmunizationRow.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__